export const CONSENT_FIELDS = [
  {
    data_name: "marketing-consent",
    label: "Email Consent",
    display_name: "Email Consent",
    has_prechecked: true,
    default_required: "false",
  },
  {
    data_name: "sms-consent",
    label: "SMS Consent",
    display_name: "SMS Consent",
    has_prechecked: false,
    default_required: "true",
  },
  {
    data_name: "privacy-consent",
    label: "Privacy Consent",
    display_name: "Privacy Consent",
    has_prechecked: true,
    default_required: "true",
  },
];

export const PRESET_FIELDS = [
  { data_name: "name", label: "First name", parameter: "firstname" },
  { data_name: "lastname", label: "Last name", parameter: "lastname" },
  { data_name: "email", label: "Email address", default_status: "true" },
  { data_name: "phone", label: "Phone number" },
  { data_name: "url", label: "Website URL", parameter: "website" },
  {
    data_name: "company-name",
    label: "Company name",
    parameter: "company_name",
  },
  {
    data_name: "company-title",
    label: "Professional title",
    parameter: "company_title",
  },
  { data_name: "city", label: "City" },
  { data_name: "state", label: "State" },
  { data_name: "country", label: "Country" },
  { data_name: "address", label: "Address" },
  { data_name: "zip-code", label: "Zip code", parameter: "zipcode" },
];

export const PRESET_FIELD_DATA_NAMES = PRESET_FIELDS.map((f) => f.data_name);

export const parsePosition = (value) => {
  const n = parseInt(value, 10);
  return Number.isFinite(n) ? n : null;
};

export const maxRegularFieldPosition = (options = {}, customFields = []) => {
  let max = PRESET_FIELD_DATA_NAMES.length;
  PRESET_FIELD_DATA_NAMES.forEach((name) => {
    const pos = parsePosition(options[name + "-position"]);
    if (pos !== null && pos > max) max = pos;
  });
  customFields.forEach((field) => {
    const pos = parsePosition(field && field.position);
    if (pos !== null && pos > max) max = pos;
  });
  return max;
};

export const defaultConsentPosition = (options, customFields, consentIndex) =>
  maxRegularFieldPosition(options, customFields) + 1 + consentIndex;

export const isInterleavedConsent = (
  options = {},
  dataName,
  customFields = []
) => {
  const pos = parsePosition(options[dataName + "-position"]);
  if (pos === null) return false;
  return pos <= maxRegularFieldPosition(options, customFields);
};

export const splitConsentPlacements = (options = {}, customFields = []) => {
  const max = maxRegularFieldPosition(options, customFields);
  const placed = CONSENT_FIELDS.map((consent, i) => {
    const stored = parsePosition(options[consent.data_name + "-position"]);
    return {
      ...consent,
      position: stored === null ? max + 1 + i : stored,
      interleaved: stored !== null && stored <= max,
    };
  }).sort((a, b) => a.position - b.position);
  return {
    interleaved: placed.filter((consent) => consent.interleaved),
    trailing: placed.filter((consent) => !consent.interleaved),
  };
};

export const nextFormFieldPosition = (options = {}, customFields = []) => {
  let max = maxRegularFieldPosition(options, customFields);
  CONSENT_FIELDS.forEach((consent) => {
    const pos = parsePosition(options[consent.data_name + "-position"]);
    if (pos !== null && pos > max) max = pos;
  });
  return max + 1;
};
